export default __webpack_public_path__ + "static/media/score.b495e8b0.png";